/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_AcceptedInputs */

const tr_geliver_substatus_package_accepted = /** @type {(inputs: Geliver_Substatus_Package_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Kabul Edildi`)
};

const en_geliver_substatus_package_accepted = /** @type {(inputs: Geliver_Substatus_Package_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Package Accepted`)
};

const de_geliver_substatus_package_accepted = /** @type {(inputs: Geliver_Substatus_Package_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket angenommen`)
};

const ru_geliver_substatus_package_accepted = /** @type {(inputs: Geliver_Substatus_Package_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посылка принята`)
};

/**
* | output |
* | --- |
* | "Package Accepted" |
*
* @param {Geliver_Substatus_Package_AcceptedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_accepted = /** @type {((inputs?: Geliver_Substatus_Package_AcceptedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_AcceptedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_accepted(inputs)
	if (locale === "de") return de_geliver_substatus_package_accepted(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_accepted(inputs)
	return tr_geliver_substatus_package_accepted(inputs)
});